import { render, staticRenderFns } from "./NavigationLeft.vue?vue&type=template&id=8b771c16&scoped=true&"
import script from "./NavigationLeft.vue?vue&type=script&lang=js&"
export * from "./NavigationLeft.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLeft.vue?vue&type=style&index=0&id=8b771c16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b771c16",
  null
  
)

export default component.exports